export const RefundStatus = {
    None: 0,
    Requesting: 1,
    Accepted: 2,
    Reject: 3,
    Refunded: 4,
    ManuallyRefunded: 5
};